import { Trans, useTranslation } from 'react-i18next'
import { isIOS } from 'react-device-detect'
import Rocketman from 'shared/images/rocketman.png'
import { Container, Logo, Subtitle, Image, Link } from './MobilePage.style'
import { config } from 'config'

const MobilePage = () => {
  const { t } = useTranslation()

  const contentProps = isIOS
    ? {
        key: 'mobilePage.titleIos',
        href: config.APPLE_STORE_PATH,
      }
    : {
        key: 'mobilePage.titleAndroid',
        href: config.ANDROID_STORE_PATH,
      }

  return (
    <Container container direction="column" alignItems="center">
      <Logo />
      <Image src={Rocketman} />
      <Subtitle>
        <Trans
          i18nKey={contentProps.key}
          components={{ em: <Link href={contentProps.href} /> }}
          t={t}
        />
      </Subtitle>
    </Container>
  )
}

export default MobilePage
